module.exports = __webpack_public_path__ + "static/media/photo3.d59a8285.jpeg";